import React from "react";

function Self_Life_forms_Edit() {
  return (
    <div className="p-5 border-2 border-gray-200 rounded-xl ">
      {/* Title */}
      <div className="border-b pb-2">
        <p className="text-lg font-semibold text-gray-700">
          Self Life & Expiry Details
        </p>
      </div>

      {/* Table-like structure */}
      <div className="mt-5 flex px-5  flex-row flex-wrap">
        <table className="w-1/2   text-sm font-medium">
          <tbody>
            {/* Row 1 */}
            <tr>
              <td className=" py-3  text-gray-700 w-1/2 ">Product Life :</td>
              <td className=" py-3  w-1/2 ">30 Days</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default Self_Life_forms_Edit;
